const VARIANTS ={
    primary: 'bg-action-primary text-primary-black',
    secondary: 'bg-primary-black text-primary-white',
    tertiary: 'bg-primary-white text-primary-black',
    disabled: 'bg-primary-black text-primary-white opacity-50',
}
interface ButtonProps {
    variant?: 'primary' | 'secondary' | 'tertiary' | 'disabled'
    className?: string
}
export const Button = ({
    variant = 'primary', 
    children, 
    className, 
    ...props }: ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    
    return (
        <button 
            className={`flex flex-row rounded-lg p-3 gap-2 w-full justify-center items-center ${VARIANTS[variant]} ${className} ${props.disabled ? VARIANTS.disabled : ''}`}
            {...props}
        >
            {children}
        </button>
    )
}